import * as types from "./mutation-type";

export default {
    [types.SET_GLOBAL](state, payload) {
        state.global = payload
    },
    [types.SET_PRIVATE](state, payload) {
        state.private = payload
    }
}
